import { Navigate, Outlet, Route, Routes, useLocation } from "react-router-dom";
import List from "./List";
import Header from "./Header";
import EditProductCategoryDetails from "./edit";
import ProductCategoryDetailsRoute from "./Details/index";
import NewProductCategory from "./New/index";
import NewProductType from "./New/index";
import EditProductTypeDetails from "./edit";
import ProductTypeDetailsRoute from "./Details/index";
import EditProductDetails from "./edit";
import NewProduct from "./New/index";
import ProductDetailsRoute from "./Details/index";

function Products() {
  const location = useLocation();

  return (
    <Routes>
      <Route
        element={
          <>
            {/* {location.pathname.includes("/items/edit-item") ? (
              <></>
            ) : (
              <Header />
            )} */}
            <Outlet />
          </>
        }
      >
        <Route
          path="/list"
          element={
            <>
              <Header />

              <List />
            </>
          }
        />

        <Route
          path="new"
          element={
            <>
              <NewProduct />
            </>
          }
        />
        <Route
          path="edit/:id"
          element={
            <>
              {/* <EditModule
                module={"items"}
                modulePath="/items"
                primary_key="item_id"
              /> */}
              <EditProductDetails />
            </>
          }
        />

        <Route
          path="details/:id"
          element={
            <>
              <ProductDetailsRoute className={""} />
            </>
          }
        />

        {/* <Route path="/summary" element={<Summary />} /> */}

        <Route index element={<Navigate to="/products/list" />} />
      </Route>
    </Routes>
  );
}

export default Products;
